document.documentElement.classList.remove('no-js');

const rootPath = window.Shopify?.routes?.root || '/';
const isPolish = document.documentElement.lang.toLowerCase().startsWith('pl');
const messages = {
  added: isPolish ? 'Dodano do koszyka: ' : 'Added to cart: ',
  addError: isPolish ? 'Nie udało się dodać produktu do koszyka.' : 'Could not add the product to cart.',
  loading: isPolish ? 'Dodawanie…' : 'Adding…'
};

function toast(message) {
  const element = document.getElementById('VelvetoryToast');
  if (!element) return;
  element.textContent = message;
  element.classList.add('show');
  window.clearTimeout(element.toastTimer);
  element.toastTimer = window.setTimeout(() => element.classList.remove('show'), 2600);
}

function initHeroSlideshow() {
  document.querySelectorAll('[data-hero-slideshow]').forEach(slideshow => {
    const slides = [...slideshow.querySelectorAll('[data-hero-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    let timer;
    const show = index => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(active + 1), 6500);
      }
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restart(); }));
    slideshow.addEventListener('mouseenter', () => window.clearInterval(timer));
    slideshow.addEventListener('mouseleave', restart);
    show(0);
    restart();
  });
}

async function refreshCartCount() {
  const cart = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } }).then(response => response.json());
  document.querySelectorAll('[data-cart-count]').forEach(element => {
    element.textContent = cart.item_count;
  });
  document.querySelectorAll('.cart-link').forEach(element => {
    element.setAttribute('aria-label', `${isPolish ? 'Koszyk' : 'Cart'}: ${cart.item_count}`);
  });
}

function getDrawer() {
  return document.querySelector('[data-mobile-menu]');
}

function openMobileMenu() {
  const drawer = getDrawer();
  const toggle = document.querySelector('[data-menu-toggle]');
  if (!drawer || !toggle) return;
  drawer.inert = false;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  toggle.setAttribute('aria-expanded', 'true');
  document.body.classList.add('is-locked');
  window.setTimeout(() => drawer.querySelector('[data-menu-close]')?.focus(), 40);
}

function closeMobileMenu({ restoreFocus = true } = {}) {
  const drawer = getDrawer();
  const toggle = document.querySelector('[data-menu-toggle]');
  if (!drawer || !toggle) return;
  drawer.inert = true;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  toggle.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('is-locked');
  if (restoreFocus) toggle.focus();
}

function showProductMedia(section, mediaId) {
  if (!mediaId) return;
  const items = section.querySelectorAll('[data-media-id]');
  const buttons = section.querySelectorAll('[data-media-target]');
  let found = false;
  items.forEach(item => {
    const active = item.dataset.mediaId === String(mediaId);
    item.hidden = !active;
    if (active) found = true;
  });
  if (!found) return;
  buttons.forEach(button => {
    const active = button.dataset.mediaTarget === String(mediaId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
}

function updateVariant(section, select) {
  const option = select.options[select.selectedIndex];
  if (!option) return;
  const price = section.querySelector('[data-product-price]');
  const comparePrice = section.querySelector('[data-compare-price]');
  const submit = section.querySelector('[data-product-submit]');
  const submitLabel = section.querySelector('[data-product-submit-label]');
  const available = option.dataset.available === 'true';

  if (price) price.textContent = option.dataset.price || '';
  if (comparePrice) {
    comparePrice.textContent = option.dataset.comparePrice || '';
    comparePrice.hidden = option.dataset.compareActive !== 'true';
  }
  if (submit) submit.disabled = !available;
  if (submitLabel && submit) submitLabel.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
  showProductMedia(section, option.dataset.mediaId);

  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
}

document.addEventListener('click', event => {
  if (event.target.closest('[data-menu-toggle]')) {
    openMobileMenu();
    return;
  }
  if (event.target.closest('[data-menu-close]')) {
    closeMobileMenu();
    return;
  }
  if (event.target.closest('[data-mobile-menu] a')) {
    closeMobileMenu({ restoreFocus: false });
  }

  const mediaButton = event.target.closest('[data-media-target]');
  if (mediaButton) {
    const section = mediaButton.closest('[data-product-section]');
    if (section) showProductMedia(section, mediaButton.dataset.mediaTarget);
    return;
  }

  const minus = event.target.closest('[data-quantity-minus]');
  const plus = event.target.closest('[data-quantity-plus]');
  if (minus || plus) {
    const control = event.target.closest('[data-quantity-control]');
    const input = control?.querySelector('input');
    if (!input) return;
    const current = Number.parseInt(input.value || '1', 10);
    input.value = String(Math.max(1, current + (plus ? 1 : -1)));
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && getDrawer()?.classList.contains('is-open')) closeMobileMenu();
});

document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const section = select.closest('[data-product-section]');
  if (section) updateVariant(section, select);
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-ajax-cart]')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const label = button?.querySelector('[data-product-submit-label]');
  const previousLabel = label?.textContent || button?.textContent || '';
  if (button) button.disabled = true;
  if (label) label.textContent = messages.loading;

  try {
    const response = await fetch(`${rootPath}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || messages.addError);
    toast(messages.added + payload.product_title);
    await refreshCartCount();
  } catch (error) {
    toast(error.message || messages.addError);
  } finally {
    if (button) button.disabled = false;
    if (label) label.textContent = previousLabel;
  }
});

function initAgeGate() {
  const gate = document.querySelector('[data-age-gate]');
  if (!gate) return;
  let storedUntil = 0;
  try {
    storedUntil = Number.parseInt(localStorage.getItem('velvetory_age_until') || '0', 10);
  } catch (error) {
    storedUntil = 0;
  }

  try { storedUntil = Math.max(storedUntil, Number(sessionStorage.getItem('velvetory_age_until')) || 0); } catch (error) {}

  if (storedUntil > Date.now()) {
    document.documentElement.classList.add('age-verified');
    gate.classList.add('is-hidden');
    gate.setAttribute('aria-hidden', 'true');
    return;
  }

  document.documentElement.classList.remove('age-verified');
  try { localStorage.removeItem('velvetory_age_until'); } catch (error) {}
  document.body.classList.add('is-locked');
  window.setTimeout(() => gate.querySelector('[data-age-yes]')?.focus(), 20);

  gate.querySelector('[data-age-yes]')?.addEventListener('click', () => {
    const days = Math.max(1, Number.parseInt(gate.dataset.storageDays || '30', 10) || 30);
    const expires = String(Date.now() + days * 86400000);
    try {
      localStorage.setItem('velvetory_age_until', expires);
    } catch (error) {}
    try { sessionStorage.setItem('velvetory_age_until', expires); } catch (error) {}
    document.documentElement.classList.add('age-verified');
    gate.classList.add('is-hidden');
    gate.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  });

  gate.querySelector('[data-age-no]')?.addEventListener('click', () => {
    const confirmation = gate.querySelector('[data-age-confirmation]');
    const denied = gate.querySelector('[data-age-denied]');
    if (confirmation) confirmation.hidden = true;
    if (denied) denied.hidden = false;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAgeGate();
  initHeroSlideshow();
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const section = select.closest('[data-product-section]');
    if (section) updateVariant(section, select);
  });
});

document.addEventListener('keydown', event => {
  const drawer = getDrawer();
  if (event.key !== 'Tab' || !drawer?.classList.contains('is-open')) return;
  const focusable = [...drawer.querySelectorAll('a[href],button,select,summary')].filter(el => el.getClientRects().length && !el.disabled);
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
  if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
});
window.addEventListener('resize', () => {
  if (window.innerWidth > 980 && getDrawer()?.classList.contains('is-open')) closeMobileMenu({restoreFocus:false});
});
